export const innerCellHorizontalPadding = "1rem"
